<template>
    <div class="home-pic-rows-root">
        <HomePic v-for="(item, index) in $config.HomePics" :key="item.name" :image="item.pic" :fillColor="item.fillColor" :last="index==3"></HomePic>
        <center>
            <div class="company-brief">&emsp;&emsp;我公司坐落在美丽的江南城市苏州，是一家专注软件研发的互联网科技公司。{{$config['Product Name']}}是公司旗下的产品之一，公司致力于为用户提供各类优质工具软件。经过团队持续投入以及对用户需求的不断搜集挖掘，我们已经推出了多款实用、备受好评的工具软件。我们后续将继续投入研发，帮助用户不断地提升办公、学习效率，提高生活满意度，让用户在使用我们产品的过程中更加轻松，无忧。</div>
        </center>

    </div>
</template>
<script>
    import HomePic from '@/components/HomePic';
    export default {
        components: {
            HomePic
        },
        data() {
            return {};
        }
    }
</script>
<style scoped>
    .home-pic-rows-root{
        width: 100%;
        height: 100%;
    }
    .company-brief{
        width:1000px;
        line-height: 3rem;
        font-size: 1.5rem;
        white-space: pre-wrap;
    }
</style>
